// src/components/onboarding/screens/IntroScreen.js
import React from 'react';
import { PrimaryButton } from '../OnboardingUI';

const IntroScreen = ({ userName, onNext }) => {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-gray-800/30 rounded-3xl overflow-hidden border border-white/10 shadow-2xl shadow-black/50 p-6">
        <div className="flex flex-col justify-center min-h-[500px]">
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg shadow-indigo-500/40">
              <span className="text-4xl">👋</span>
            </div>
            <h1 className="text-2xl font-bold text-gray-100">Salut {userName} !</h1>
            <p className="text-gray-400 mt-2">Quelques questions sur toi avant de commencer.</p>
          </div>

          <div className="bg-indigo-500/10 border border-white/10 rounded-2xl p-5 mb-8">
            <div className="flex items-center gap-3 mb-3">
              <span className="text-green-400">✓</span>
              <span className="text-gray-300 text-sm">Pas de bonnes ou mauvaises réponses</span>
            </div>
            <div className="flex items-center gap-3 mb-3">
              <span className="text-green-400">✓</span>
              <span className="text-gray-300 text-sm">Pas de note, pas de jugement</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-green-400">✓</span>
              <span className="text-gray-300 text-sm">Juste de quoi te proposer des trucs qui te correspondent</span>
            </div>
          </div>

          <p className="text-gray-500 text-center mb-6">Ça prend 2 minutes.</p>

          <PrimaryButton onClick={onNext}>
            C'est parti →
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default IntroScreen;
